<template>
  <div class="onepager-container offerte" :class="environment">
    <onepager
        v-for="onepager in onepagers"
        :key="onepager.type"
        :environment="environment"
        :logo="logo"
        :multiRowPath="onepager.multiRowPath"
        :products="onepager.products"
        :tableConfig="onepager.tableConfig"
        :template="getTemplateManager(onepager.template)"
        :type="onepager.type"
    ></onepager>
    <document-container
        v-if="environment === 'hanvb' && onepagers.length > 0"
        :body="appendBody"
        :footer="appendFooter"
        :header="appendHeader"
        :logo="logo"
        documentType="onepager"
    ></document-container>
  </div>
</template>

<script>
import Onepager
  from '../onepager/Onepager'
import ProductService
  from "../../service/ProductService"
import ConfigService
  from "../../service/ConfigService"
import {
  EventBus,
} from "../../service/EventBus"
import TemplateManager
  from '../../service/TemplateManager'
import TokenService
  from "../../service/TokenService"
import DocumentContainer
  from "../document/DocumentContainer"

export default {
  name: 'onepager-container',

  // vue-head is used to set & update the css
  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: `/config/${this.environment}/style/onepager.css`,
        },
      ]
    },
  },

  components: {
    DocumentContainer,
    Onepager,
  },

  data: function () {
    return {
      onepagers: [],
      pageCounter: 0,
      token: null,
      appendHeader: [
        {
          "type": "Pagetitle",
          "position": "append",
          "sort": 1,
          "title": "Disclaimer",
        },
      ],
      appendBody: [
        {
          "position": "append",
          "type": "Textblock",
          "body": [
            "Die angegebenen Chancen-/Risikoklassen (RK) beschreiben die möglichen Kursschwankungen und Verlustrisiken: | 1 - geringe Kursschwankungen | 2 - mäßige Kursschwankungen | 3 - starke Kursschwankungen, ggf. Kapitalverluste | 4 - erhebliche Kursschwankungen, ggf. Kapitalverluste | 5 - Risiko von Totalverlusten | Die Risikoklassen-Einstufung bezieht sich auf den Zeitpunkt der Emission und kann sich während der Laufzeit ändern. Bitte beachten Sie den Disclaimer am Ende des Dokumentes.",
            "<br><br>",
            "<u>Disclaimer</u>",
            "Diese Marketingmitteilung wurde von der Hannoverschen Volksbank, Bereich Wertpapiergeschäft, (im Folgenden die \"Verfasserin\") erstellt und ist zur Verteilung in der Bundesrepublik Deutschland bestimmt. Sie richtet sich nicht an Personen mit Wohn- und/oder Gesellschaftssitz und/oder Niederlassungen sowie Gerichtsstand im Ausland, vor allem in den Vereinigten Staaten von Amerika, Kanada, Großbritannien und Japan. Diese Marketingmitteilung darf im Ausland nur im Einklang mit den dort geltenden Rechtsvorschriften verteilt werden und Personen, die in den Besitz dieser Informationen und Materialien gelangen, haben sich über die dort geltenden Rechtsvorschriften zu informieren und diese zu befolgen.",
            "Die Verfasserin hat die Informationen, auf die sich die Marketingmitteilung stützt, aus als zuverlässig erachteten Quellen übernommen, ohne jedoch die Informationen selbst zu verifizieren. Die genutzten Quellen sind u.a. öffentlich zugängliche Publikationen der Emittenten, einschlägige Kursinformations- und Datenbanksysteme, Informationsdienste, allgemeine Pressemedien und Ratingagenturen. Eine Prüfung erfolgte ausschließlich auf Plausibilität; insbesondere gilt dies für verwandte Research-Informationen. Ein eigenes Research erfolgte nicht. Dementsprechend gibt die Verfasserin keine Gewährleistung oder Zusicherung hinsichtlich der Vollständigkeit oder Richtigkeit der enthaltenen Informationen, Einschätzungen oder Meinungen ab. Sie übernimmt keine Haftung für Verluste, die durch die Verteilung und/oder Verwendung der Marketingmitteilung verursacht und/oder mit der Verteilung/Verwendung der Marketingmitteilung im Zusammenhang stehen. Obgleich die Verfasserin Internetlinks, -seiten und/oder -adressen von den in dieser Marketingmitteilung erwähnten Unternehmen und/oder Emittenten angeben kann, bedeutet die Nennung nicht, dass die Verfasserin sämtliche Daten auf der genannten Internetadresse bzw. Daten, auf welche von dieser Internetadresse aus zugegriffen werden kann, prüft, bestätigt, empfiehlt oder genehmigt.",
            "Eine Investitionsentscheidung bezüglich jeglicher Wertpapiere oder sonstiger Finanzinstrumente kann und sollte auf der Grundlage eines Beratungsgespräches sowie eines Verkaufsprospekts/einer Verkaufsunterlage oder einer Produktinformation erfolgen und auf keinen Fall ausschließlich auf der Grundlage dieser Marketingmitteilung. Die Aussagen und/oder Meinungen können je nach den speziellen Anlagezielen, dem Anlagehorizont, den individuellen Vermögensverhältnissen, der Risikobereitschaft oder den vorhandenen Kenntnissen/Erfahrungen mit Wertpapieren bzw. sonstigen Finanzinstrumenten für einzelne Anleger nicht oder nur bedingt geeignet sein. Der allein verbindliche Verkaufsprospekt ist bei der Hannoverschen Volksbank eG, Kurt-Schumacher-Straße 19, 30159 Hannover erhältlich.",
            "Die Aussagen und/oder Meinungen zu Wertpapieren oder sonstigen Finanzinstrumenten sowie genannte Kurse oder Preise entsprechen dem Stand zum Zeitpunkt der Erstellung der Marketingmitteilung. Diese können aufgrund späterer Entwicklungen überholt sein, ohne dass das Dokument geändert wurde. Aufsichtsbehörde ist die Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin), Graurheindorfer Str.108, 53117 Bonn.",
          ],
        },
      ],
      appendFooter: [
        {
          "position": "footer",
          "type": "Textblock",
          "class": "offerte-footer-contact",
          "body": [
            "Hannoversche Volksbank eG | Kurt-Schumacher-Str. 19 | 30159 Hannover | Telefon 0511 1221-0 | www.hannoversche-volksbank.de | info@hannoversche-volksbank.de",
          ],
        },
      ],
    }
  },

  props: {
    environment: {
      type: String,
      required: true,
    },
    productIds: {
      type: String,
      required: true,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  methods: {
    getTemplateManager(template) {
      return new TemplateManager(template)
    },
    fetchProducts() {
      const typeMap = {
        BOND: 'offerte_bonds',
        FUND: 'offerte_funds',
        STOCK: 'offerte_stock',
        DERIVATE: 'offerte',
        CUSTOM: 'offerte_custom',
      }

      ProductService.getProductsFromBroker(
          this.environment,
          this.appInstance,
          this.productIds.split('+'),
          this.token,
          'OFFERTE_DEFAULT',
      ).then(result => {
            result.data.data.map(instrumentType => {
              let sortedResult = this._.sortBy(instrumentType.onepagers.reduce((sum, el) => {
                let idx = sum.map(el => el.type).indexOf(el.type)

                if (idx >= 0 && !(el.type === 'QTR0')) {
                  sum[idx].products = [...sum[idx].products, ...el.products]
                } else {
                  sum.push(el)
                }

                return sum
              }, []), 'type')


              sortedResult.map(productsByType => {
                ConfigService.getDocumentConfig(
                    this.environment,
                    typeMap[instrumentType.type],
                    'default',
                    productsByType.type ? productsByType.type : 'default',
                ).then(documentConfig => {

                  if (productsByType.market === 'PRIMARY') {
                    documentConfig.data.title.title += ' in Zeichnung'
                  }
                  if (productsByType.type === 'QTR0') {
                    if (productsByType.market === 'PRIMARY') {
                      documentConfig.data.intro.body = ['Diese Offerte ist eine werbliche Kundenpublikation, die eine Auswahl von Wertpapieren mit mäßigen bis erheblichen Kursschwankungen umfasst. Es besteht das Risiko von Kapitalverlusten. Die genannten Ausgabepreise beinhalten den Bankertrag und sind freibleibend. Verbindliche Ausgabepreise sowie weitere Finanzinstrumente erhalten Sie gerne auf Nachfrage. Für jedes Wertpapier halten wir ein Basisinformationsblatt für Sie bereit. Alle Angaben ohne Gewähr. Allein maßgeblich ist der Emissionsprospekt.']
                    } else {
                      documentConfig.data.intro.body = ['Diese Offerte ist eine werbliche Kundenpublikation, die eine Auswahl von Wertpapieren mit mäßigen bis erheblichen Kursschwankungen umfasst. Es besteht das Risiko von Kapitalverlusten. Für jedes Wertpapier halten wir ein Basisinformationsblatt für Sie bereit. Alle Angaben ohne Gewähr. Allein maßgeblich ist der Emissionsprospekt. Die Abrechnung erfolgt zum aktuellen Kurs zuzüglich Provision und Spesen. ']
                    }
                  }

                  documentConfig.data.title.subtitle = this.moment().format('DD. MMMM YYYY')

                  this.onepagers.push({
                    template: documentConfig.data,
                    products: productsByType.products,
                    tableConfig: productsByType.columns,
                    multiRowPath: productsByType.pathToMultiRowCount,
                  })
                })
              })
            })
          },
      )
    },
  },

  computed: {
    logo() {
      if (this.environment === 'hanvb') {
        return ['config', this.environment, 'images', this.$route.query.context === 'OFFERTE_DEFAULT' ? 'offerte_logo.jpg' : 'offerte_logo_info.jpg'].join('/')
      } else {
        return ['config', this.environment, 'images', 'logo.png'].join('/')
      }
    },
  },

  async created() {
    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }
    this.fetchProducts()
  },

  mounted() {
    EventBus.$on('pageCounter', amount => {
      this.pageCounter += amount
    })
  },

  watch: {
    // changes in the url are applied instantaneously
    environment() {
      this.$emit('updateHead')
    },
    productIds() {
      this.onepagers = []
      this.fetchProducts()
    },
    // token() {
    //   this.fetchProducts()
    // }
  },
}
</script>




// WEBPACK FOOTER //
// Offerte.vue?c7edbaee